// utils/sendQuotation.js
export const sendQuotation = async (
  email,
  productIds,
  totalPrice,
  discountCoupon = "",
  postalCode = "",
  gstAmount = "",
  shippingCharges = 0
) => {
  const baseUrl = process.env.REACT_APP_API_URL;
  const apiUrl = `${baseUrl}/api/Coltec/GenerateQuotation`;

  // Ensure productIds is a comma-separated string if passed as an array
  const productIdsString = Array.isArray(productIds)
    ? productIds.join(",")
    : productIds;

  // Build the JSON body
  const requestBody = {
    email,
    productIds: productIdsString,
    totalPrice,
    discountCoupon,
    postalCode,
    gstAmount,
    shippingCharges,
  };

  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        // Include JSON headers
        "Content-Type": "application/json",
        accept: "*/*",
      },
      // Convert JS object to JSON string
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to generate quotation");
    }

    // Parse and return the JSON response
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};
